var React = require('react');

function CheckBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0083A0","d":"M14.5 2.417c-6.673 0-12.083 5.41-12.083 12.083S7.827 26.583 14.5 26.583s12.083-5.41 12.083-12.083S21.173 2.417 14.5 2.417Zm-.967 18.2-6.2-6.2 2.734-2.734 3.466 3.466 6.284-6.283L22.55 11.6l-9.018 9.018Z"}));
}

CheckBlue.defaultProps = {"width":"29","height":"29","fill":"none","viewBox":"0 0 29 29"};

module.exports = CheckBlue;

CheckBlue.default = CheckBlue;
